<template>
  <div>
    <div v-if="routeData" style="height: 530px; border-bottom: 2px solid #297286; border-right: 2px solid #297286;">
      <v-sheet height="530">
        <v-timeline class="overflow-y-auto" side="end">
          <v-timeline-item
            dot-color="white"
            size="large"
            v-for="(item, i) in routeData"
            :key="i"
          >

              <template v-slot:icon>
                <v-avatar>
                  <img
                    v-if="item.taskStatus === 'SUSPECT'"
                    src="../assets/wgmm_ico_map_suspect.svg"
                  />
                  <img
                    v-else-if="item.taskStatus === 'VALID'"
                    src="../assets/wgmm_ico_map_valid.svg"
                  />
                  <img
                    v-else-if="item.taskStatus === 'UNDER_REVIEW'"
                    src="../assets/wgmm_ico_map_in_review.svg"
                  />
                  <img v-else src="../assets/wgmm_ico_map_other_address.svg" />
                </v-avatar>
              </template>
							<v-scroll>
              <v-row class="pt-1">
                <v-col cols="6">
                  <v-icon
                    title="Task completed time"
                    color="rgba(21, 102, 124, 0.9)"
                    >mdi-clock</v-icon
                  >
                  <strong>{{
                    justTimeForTaskDailyRoute(item.dateEnd, item.taskUUID)
                  }}</strong>
                </v-col>
                <v-col>
                  <v-row>
                    <div class="test2">{{ item.DUID || "No DU" }}</div>
                  </v-row>
                  <v-row>
                    <div>
                      <v-icon
                        title="Task duration"
                        color="rgba(21, 102, 124, 0.9)"
                        >mdi-clock</v-icon
                      >
                      <span>
                        <label
                          class="label label-primary test"
                          title="Task duration"
                          >{{
                            item.clusterDuration
                              ? covertDurationForTaskDailyRoute(
                                  item.clusterDuration
                                )
                              : "00h 00m"
                          }}</label
                        >
                      </span>
                      <v-icon
                        color="blue"
                        v-if="item.pointCompletedType === 'LAPTOP'"
                        title="Laptop track"
                        >mdi-laptop</v-icon
                      >
                      <v-icon v-else title="No laptop track">mdi-laptop</v-icon>
                      <v-icon
                        color="orange"
                        v-if="item.pointCompletedType === 'PHONE'"
                        title="Phone track"
                        >mdi-cellphone</v-icon
                      >
                      <v-icon v-else title="No phone track"
                        >mdi-cellphone</v-icon
                      >
                    </div>
                  </v-row>
                </v-col>
              </v-row>
            </v-scroll>
          </v-timeline-item>
        </v-timeline>
      </v-sheet>
    </div>
  </div>
</template>

<script>
import { dateService } from "@/services/date.service.js";
import { STORE_CONSTANTS } from "@/common/store.constants";
import { mapGetters } from "vuex";

export default {
  name: "RouteViewTable",
  props: {
    criteria: Object,
  },
  computed: {
    ...mapGetters("dailyTasks", ["getStaffDailyTaskList"]),
    ...mapGetters("tracks", ["getTaskFeatures"]),
  },
  watch: {
    criteria: function (newValue, oldValue) {
      if (newValue !== oldValue) {
        this.criteria = newValue;
      }
    },
  },
  data: () => ({
    STORE_CONSTANTS,
    routeData: null,
    taskFeaturesList: null,
  }),
  mounted() {
    const me = this; // scoped this as in the component

    me.routeData = me.getStaffDailyTaskList;
    me.taskFeaturesList = {};
    const features = me.getTaskFeatures;
    features.forEach((feature) => {
      me.taskFeaturesList[feature.id] = feature;
    });

    me.unsubscribe = me.$store.subscribe((mutation, state) => {
      if (
        mutation.type ===
        me.STORE_CONSTANTS.DAILY_TASKS.MUTATIONS.WITH_NAMESPACE
          .SET_STAFF_DAILY_TASKS
      ) {
        me.routeData = state.dailyTasks.staffDaily.tasks;
        me.taskFeaturesList = {};
        const features = me.getTaskFeatures;
        features.forEach((feature) => {
          me.taskFeaturesList[feature.id] = feature;
        });
      }
    });
  },
  beforeDestroy() {
    if (this.unsubscribe) {
      this.unsubscribe();
    }
  },
  methods: {
    justTimeForTaskDailyRoute(date, taskId) {
      if (!this.taskFeaturesList) {
        return date;
      }
      const point = this.taskFeaturesList[taskId];
      // console.log('justTimeForTaskDailyRoute date: ', date)
      let latLng = {
        lat: point.geometry.coordinates[1],
        lon: point.geometry.coordinates[0],
      };
      let finalTime = dateService
        .formatDateTimeBottomTable(date, latLng)
        .substring(10);
      return finalTime;
    },
    covertDurationForTaskDailyRoute(duration) {
      let minutes = Math.floor((duration / (1000 * 60)) % 60);
      let hours = Math.floor((duration / (1000 * 60 * 60)) % 24);
      hours = hours < 10 ? "0" + hours : hours;
      minutes = minutes < 10 ? "0" + minutes : minutes;
      return hours + "H " + minutes + "M";
    },
  },
};
</script>

<style>
.test {
  color: white;
  background-color: #337ab7;
  display: inline;
  padding: 0.2em 0.6em 0.3em;
  font-size: 75%;
  font-weight: 700;
  line-height: 1;
  color: #fff;
  text-align: center;
  white-space: nowrap;
  vertical-align: baseline;
  border-radius: 0.25em;
}

.test2 {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  font-weight: bold;
}
</style>
